export class Branch {

    id: number;
    name: string;
    city: string;
    code: string;
    address: string;
    phone: string;
    fax: string;
    lat = '';
    lng = '';

}
